import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import flow from 'lodash/fp/flow';
import { oopsGreen, white } from '../../../styles/style-constants';
import WebLink from '../WebLink';
import config from 'config';
import { translate } from '../../../translations/translator';
import { getTranslatedImage } from '../../../translations/translator';
import { FONT_GSS_FUTURA } from 'themes/default';
import { makeStyles } from '@mui/styles';
const translateErrors = key => translate('errors', key);

// type Props = {
//   disableErrorRouteRedirection?: () => void;
// };

const Page500 = () => {
  const navigate = useNavigate();
  const classes = useStyles();

  const handleGoBack = () => {
    navigate(-2);
  };

  const renderButtons = () => {
    const { buttons, anchor } = classes;

    return (
      <div className={buttons}>
        <button className={anchor} onClick={handleGoBack}>
          {translateErrors('goBack')}
        </button>
        <WebLink
          className={anchor}
          to={`mailto:${config.supportEmail}`}
          name={translateErrors('contact')}
        />
      </div>
    );
  };

  const { page500, image, textSection, span, heading1, heading2 } = classes;

  return (
    <div className={page500}>
      <img alt="oops" src={getTranslatedImage('500-oops-kid.png')} className={image} />
      <section className={textSection}>
        <span className={span}>{translateErrors('500Title')}</span>
        <h1 className={heading1}>{translateErrors('wrong')}</h1>
        <h2 className={heading2}>{translateErrors('internalError')}</h2>
        {renderButtons()}
      </section>
      <p style={{ marginTop: 30 }}>Version: {process.env.REACT_APP_APP_VERSION}</p>
    </div>
  );
};

const useStyles = makeStyles(() => ({
  page500: {
    fontFamily: FONT_GSS_FUTURA,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.2rem',
    backgroundColor: white
  },
  image: {
    height: '80%',
    marginRight: '5%'
  },
  textSection: {
    position: 'relative',
    top: '-8%'
  },
  span: {
    fontSize: '1.3rem',
    fontWeight: 300
  },
  heading1: {
    fontSize: '3.5rem',
    margin: '0.5rem 0',
    fontWeight: 500
  },
  heading2: {
    fontSize: '1.5rem',
    margin: 0,
    fontWeight: 300
  },
  buttons: {
    margin: '1.2rem 0'
  },
  anchor: {
    border: 'none',
    borderRadius: '0.2rem',
    backgroundColor: oopsGreen,
    color: white,
    margin: '0 0.5rem 0 0',
    padding: '0.35rem 1.2rem',
    fontSize: '0.8rem',
    fontWeight: 500,
    cursor: 'pointer',
    '&:focus': {
      outline: 'none'
    },
    '&:visited': {
      backgroundColor: oopsGreen,
      color: white,
      textDecoration: 'none'
    },
    '&:active': {
      backgroundColor: oopsGreen,
      color: white,
      textDecoration: 'none'
    },
    '&:hover': {
      color: white,
      textDecoration: 'none'
    },
    '&:link': {
      backgroundColor: oopsGreen,
      color: white,
      textDecoration: 'none'
    }
  }
}));

const withRedux = connect(null /*{ disableErrorRouteRedirection }*/);

export default flow(withRedux)(Page500);
